import { Pipe, PipeTransform } from '@angular/core';
import { Money } from '../models/money.model';
import { MoneyService } from '../services/money.service';

@Pipe({
  name: 'flyMoney',
  standalone: false
})
export class MoneyPipe implements PipeTransform {
  constructor(readonly moneyService: MoneyService) {}

  transform(money?: Money | null): string | null {
    if (money == null) {
      return null;
    } else {
      return this.moneyService.getFormattedValue(money);
    }
  }
}
